export function OutlineChevronLeftIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00012 11.535L8.83012 14.365L13.9501 19.485C14.7301 20.265 16.0001 20.265 16.7801 19.485C17.1701 19.095 17.3701 18.585 17.3701 18.075C17.3701 17.565 17.1701 17.045 16.7801 16.655L11.6601 11.535L16.7801 6.415C17.5601 5.635 17.5601 4.365 16.7801 3.585C16.0001 2.805 14.7301 2.805 13.9501 3.585L6.00012 11.535Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
